import { getReq, postReq, putReq, deleteReq, createUrl } from '@/infra/http';
import { PagedResponseModel, BaseResponseModel, PaginatedSelectModel } from '@/models/core.model';
import { PointType, PointTypeAiStyle, PointTypePaginationFilter, UpsertPointType, UpsertPointTypeAiStyle, pointTypeFromJson } from '@/models/point-type.model';

export const getPagedPointTypes = async (input: PointTypePaginationFilter): Promise<PagedResponseModel<PointType>> => {
  return await getReq(createUrl('a/PointType/PagedData'), { params: input })
    .then((res: any) => ({
      ...res.data,
      result: res.data.result.map((itm: any) => pointTypeFromJson(itm)),
    }));
};

export const getPointTypesLookup = async (input?: string, page?: number, onlyActive?: boolean): Promise<PaginatedSelectModel> => {
  const model: PointTypePaginationFilter = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: input,
    orderBy: 'CreatedAt',
    isAscending: true,
    isActive: onlyActive ? true : undefined,
  };
  return await getPagedPointTypes(model).then(data => ({
    data: data.result.map(itm => ({ value: itm.id, label: `${itm.name} (${itm.key})` })),
    isLastPage: data.pageNumber >= data.totalPages,
  }));
};

export const getPointType = async (id: number): Promise<BaseResponseModel<PointType>> => {
  return await getReq(createUrl(`a/PointType/${id}`))
    .then((res: any) => ({ ...res.data, result: pointTypeFromJson(res.data.result) }));
};

export const upsertPointType = async (input: UpsertPointType): Promise<BaseResponseModel<PointType>> => {
  const { id, ...body } = input;
  const req = id ? putReq(createUrl(`a/PointType/${id}`), body) : postReq(createUrl('a/PointType'), body);
  return await req.then((res: any) => res.data);
};

export const getPointTypeAiStyles = async (id: number): Promise<BaseResponseModel<PointTypeAiStyle[]>> => {
  return await getReq(createUrl(`a/PointType/${id}/AiStyle`)).then((res: any) => res.data);
};

export const addPointTypeAiStyle = async (id: number, input: UpsertPointTypeAiStyle): Promise<BaseResponseModel<PointTypeAiStyle>> => {
  return await postReq(createUrl(`a/PointType/${id}/AiStyle`), input).then((res: any) => res.data);
};

export const deletePointTypeAiStyle = async (id: number, aiStyleId: number): Promise<BaseResponseModel<null>> => {
  return await deleteReq(createUrl(`a/PointType/${id}/AiStyle/${aiStyleId}`)).then((res: any) => res.data);
};
